import React from 'react';
import { AlertTriangle, CircleHelp } from 'lucide-react';
import ModalShell from '../Modal/ModalShell';

export default function ConfirmDialog({
  title,
  message,
  onConfirm,
  onCancel,
  isDangerous = false,
  confirmLabel,
  isLoading = false,
  loadingLabel = 'Working...',
  eyebrow,
}) {
  const Icon = isDangerous ? AlertTriangle : CircleHelp;
  return (
    <ModalShell
      title={title}
      subtitle={message}
      eyebrow={eyebrow || (isDangerous ? 'Permanent action' : 'Please confirm')}
      icon={Icon}
      tone={isDangerous ? 'danger' : 'warning'}
      size="sm"
      onClose={isLoading ? () => {} : onCancel}
      bodyClassName="confirm-popup-body"
    >
      <div className="modal-footer confirm-popup-footer">
        <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={isLoading}>Cancel</button>
        <button type="button" className={isDangerous ? 'btn btn-danger-solid' : 'btn btn-primary'} onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <><span className="spinner" /> {loadingLabel}</> : (confirmLabel || (isDangerous ? 'Delete' : 'Confirm'))}
        </button>
      </div>
    </ModalShell>
  );
}
